var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 148,
    viewBox: "0 0 148 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M147.44 73.72C147.44 114.434 114.434 147.44 73.72 147.44C33.0102 147.44 0 114.434 0 73.72C0 33.0102 33.0102 0 73.72 0C114.434 0 147.44 33.0102 147.44 73.72Z",
    fill: "#D8D8D8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0989 81.9111C52.7537 81.9111 57.3378 75.4933 57.3378 67.5766C57.3378 59.6599 52.7537 53.2422 47.0989 53.2422C41.4441 53.2422 36.86 59.6599 36.86 67.5766C36.86 75.4933 41.4441 81.9111 47.0989 81.9111Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.341 81.9111C105.996 81.9111 110.58 75.4933 110.58 67.5766C110.58 59.6599 105.996 53.2422 100.341 53.2422C94.6863 53.2422 90.1022 59.6599 90.1022 67.5766C90.1022 75.4933 94.6863 81.9111 100.341 81.9111Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M102.389 106.484H45.0511C42.7904 106.484 40.9556 104.653 40.9556 102.389C40.9556 100.124 42.7904 98.293 45.0511 98.293H102.389C104.654 98.293 106.484 100.124 106.484 102.389C106.484 104.653 104.654 106.484 102.389 106.484Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/okay.3b5e073c34f711c38f1fd5eef0aa0ab0.svg";
export { ForwardRef as ReactComponent };